module.exports = __webpack_public_path__ + "assets/img/news_32_logo4.f3f65b84.png";